import moment from "moment";
import SHA256 from "crypto-js/sha256";
import Vue from "vue";
var XMLparser = require("xml2json-light");

const L_API = process.env.VUE_APP_LASKUMAPPI_API;
const GOPI_URL = process.env.VUE_APP_GOPI
//const GOPI_URL = "http://localhost:11001"

const AUTH_SERVER = GOPI_URL + "/token/auth";
const ADMIN_API = process.env.VUE_APP_ADMIN_API

export const tokenHandler = {
  install(Vue, { store }) {
    let allowRefresh = true;
    Vue.http.interceptors.push((request, next) => {
      const userData = store.state.user.userData;
      if (allowRefresh) {
        const hasAuthHeader = request.headers.has("Authorization");
        if (hasAuthHeader) {
          request.headers.set(
            "Authorization",
            "Bearer " + store.state.user.authToken
          );
        } else {
          allowRefresh = false;
          return Vue.http(request);
        }
        next(response => {
          if (response.status == 403) {
            allowRefresh = false;
            return fetchAuthToken(userData.TransferID, userData.TransferKey).then(
              response => {
                store.commit("SET_AUTH_TOKEN", response.token);
                request.headers.set(
                  "Authorization",
                  "Bearer " + response.token
                );
                return Vue.http(request)
                  .then(response => {
                    return response;
                  })
                  .catch(response => {
                    return response;
                  });
              }
            );
          }
        })
      }
      allowRefresh = true;
    });
  }
};
export function fetchAuthToken(tid, tkey) {
  return new Promise((resolve, reject) => {
    let params = authParams(tid, tkey);
    Vue.http
      .get(AUTH_SERVER, { params: params })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
const authParams = (tid, tkey) => {
  let t = moment()
    .utc()
    .format("YYYYMMDDHHmmss");
  let digest = "SHA-256:" + SHA256([tid, t, tkey].join("+"));

  return {
    TraID: tid,
    Timestamp: t,
    Digest: digest
  };
};
const digestStringWithValue = (args, value) => {
  //Ember.Logger.log(args.join('+'));
  if (value) {
    args.push(SHA256(value));
  }
  //Ember.Logger.log(args.join('+'));
  let digest = "SHA-256:" + SHA256(args.join("+"));
  //Ember.Logger.log(digest);
  return digest;
};

export const login = function ({ name, pass }) {
  return new Promise((resolve, reject) => {
    let t = moment()
      .utc()
      .format("YYYYMMDDHHmmss");
    let d = digestStringWithValue([name, t], pass);
    Vue.http
      .get(L_API + "/login", {
        params: {
          uid: name,
          app: "laskumappi",
          t,
          d
        }
      })
      /* .then(response => response.json()) */
      .then(data => {
        if (data.status === 200) {
          //let json = transformToObject(response.body);
          data.json().then(data => {
            if (data.Response.Status === "OK") {
              resolve(data.Response.Content.Group);
            } else if (data.Response.FreeText[1].$ === "ACCOUNT LOCKED"){
              reject("login.accountLocked");
            } else {
              reject("login.wrongPass");
            }
          })
        } else {
          reject("login.serviceDown")
        }

      })
      .catch(error => {
        reject(error);
      });
  });
};
export const getSession = function ({ TraID, tkey }) {
  return new Promise((resolve, reject) => {
    let t = moment()
      .utc()
      .format("YYYYMMDDHHmmss");
    let d = digestStringWithValue([TraID, t, tkey]);
    Vue.http
      .get(L_API + "/session", {
        params: {
          TraID,
          t,
          d
        }
      })
      /* .then(response => response.json()) */
      .then(data => {
        if (data.status === 200) {
          //let json = transformToObject(response.body);
          data.json().then(data => {
            if (data.Response.Status === "OK") {
              resolve(data.Response.Content.Group);
            } else {
              reject("login.wrongPass");
            }
          })
        } else {
          reject("login.serviceDown")
        }

      })
      .catch(error => {
        reject(error);
      });
  });
};
export const deleteSession = function ({ TraID, tkey }) {
  let t = moment()
    .utc()
    .format("YYYYMMDDHHmmss");
  let d = digestStringWithValue([TraID, t, tkey]);
  Vue.http
    .delete(L_API + "/session", {
      params: {
        TraID,
        t,
        d
      }
    })
    .catch(error => {
      console.log(error)
    });
};
function decodeHTML(str) {
  return str
    .replace(/&apos;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, ">")
    .replace(/&lt;/g, "<")
    .replace(/&amp;/g, "&");
}

export function transformToObject(data) {
  data = decodeHTML(data);
  return XMLparser.xml2json(data);
}

export function listB2C(req) {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(GOPI_URL + "/b2c/invoices", {
        params: req,
        headers: { Authorization: "dummy" }
      })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function listInvoicers() {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(GOPI_URL + "/b2c/invoicers", {
        headers: { Authorization: "dummy" }
      })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getInvoicee(req) {
  return new Promise((resolve, reject) => {
    Vue.http
      .get(GOPI_URL + `/b2c/invoicee/${req}`, {
        headers: { Authorization: "dummy" }
      })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}


export function updateInvoicee(request) {
  return new Promise((resolve, reject) => {
    return Vue.http
      .put(GOPI_URL + "/b2c/invoicee", request, {
        headers: { Authorization: "dummy" }
      })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function deleteInvoices(request) {
  return new Promise((resolve, reject) => {
    return Vue.http
      .delete(GOPI_URL + "/b2c/invoices", {
        headers: { Authorization: "dummy" },
        body: request,
      })
      .then(response => response.json())
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}



export function queryYTJ(bid) {
  return new Promise((resolve, reject) => {
    return Vue.http.get(GOPI_URL + "/ytj/" + bid, { headers: { 'Authorization': 'Bearer dummy', 'Content-Type': 'application/json' } })
      .then((response) => response.json()).then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function listContract({ TraID, tkey, cid }) {
  return new Promise((resolve, reject) => {
    let t = moment()
      .utc()
      .format("YYYYMMDDHHmmss");
    let d = digestStringWithValue([cid, TraID, t, tkey]);
    Vue.http.get(ADMIN_API +
      "/listcontract", {
      params: {
        TraID,
        cid,
        t,
        d
      },
      headers: { 'Content-Type': 'text/xml', 'Accept': 'text/xml' }
    }).then(response => {
      response = transformToObject(response.body)
      if (response.Response.Status === "OK") {
        resolve(response.Response.Content.Group)
      } else {
        reject(response)
      }
    }).catch(error => {
      reject(error)
    })
  })
}